import { appEnv } from 'src/util/appEnv'

const localNodeUUIDs = ['33265369-3af6-4f96-981d-7b736dd34aa1']

const devNodeUUIDs: string[] = ['37b83fe5-e699-4b04-aa54-b01c9878ee05']

const prodNodeUUIDs: string[] = [
  // companyId: 93
  // templateId: 242071
  // templateName: 編集禁/カミナシ作成_総合判定付き野菜殺菌IoT
  '42750f0d-9464-4206-889f-241d586aabdd',
]

// IoT 機器の読み取りボタンの表示対象の場合、 true を返す
export function isIoT(nodeUUID: string | undefined): boolean {
  let nodeUUIDs: string[]
  switch (true) {
    case appEnv.isLocal:
      nodeUUIDs = localNodeUUIDs
      break
    case appEnv.isDevelopment:
      nodeUUIDs = devNodeUUIDs
      break
    case appEnv.isProduction:
      nodeUUIDs = prodNodeUUIDs
      break
    default:
      nodeUUIDs = []
  }

  return nodeUUID && nodeUUIDs.includes(nodeUUID) ? true : false
}
